"use client";
// 2026-09-07 chat lazy island — dynamic ssr:false must live in a Client Component
// (next/dynamic forbids ssr:false in Server Components; page.tsx stays server for metadata).
// "use client" justified: this is the interactive workspace island, cannot be server.
import dynamic from "next/dynamic";
import { ChatSkeleton } from "@/components/chat/chat-skeleton";

export const ChatWorkspaceLazy = dynamic(
  () => import("@/components/chat/ChatWorkspace").then((module) => module.ChatWorkspace),
  {
    loading: () => <ChatSkeleton />,
    ssr: false,
  }
);
